import { useEffect, useState } from 'react';
import { resolveVariant, trackExposure, TEST } from '../../utils/experimentAssignment';
import Landing from '../Landing/Landing';
import BaseLandingV4 from '../CustomLandings/BaseLandingV4/BaseLandingV4';

// BaseLandingV4's layout and image with the control hero's text. A new key, so
// assignments stored for the ended benefithub-landing-v4 test don't carry over.
const FLAG_KEY = 'benefithub-landing-v4-control-hero';

// Share of /benefithub visitors entering the experiment at all. Keep this in sync
// with the flag's rollout in PostHog, since a visitor with cached flags is
// assigned by the flag instead.
const ENROLLED_SHARE = 1.0;

// Share of *enrolled* visitors who see BaseLandingV4 with the control hero copy.
const TEST_SHARE = 0.50;

export default function BenefitHubExperimentEntry() {
    // Resolved once, synchronously, so the correct page paints on the first
    // render — no gate and no swap.
    const [assignment] = useState(() =>
        resolveVariant({ flagKey: FLAG_KEY, enrolledShare: ENROLLED_SHARE, testShare: TEST_SHARE })
    );

    useEffect(() => {
        trackExposure(FLAG_KEY, assignment.variant);
    }, [assignment.variant]);

    if (assignment.variant === TEST) {
        return <BaseLandingV4 controlHeroCopy />;
    }

    return <Landing />;
}
